import { Component, ojs, app, state, v, payload } from "modular-openscriptjs";
import {
  pageInfo,
  inform,
  consoleErrorOnLocal,
  cleanDispose,
  eParse,
  scrollToTop,
} from "../../../helpers";
import { api } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";
import { dom, tool } from "../../../fotastart";
import { $e } from "../../../ojs.events";
import Spinner, { SmallSpinner } from "../../Blocks/Spinner";

const h = app("h");
const router = app("router");
const broker = app("broker");

ojs(SolidIcon, Spinner, SmallSpinner);

export default class ManageBranch extends Component {
  branchId = null;
  companyId = null;
  branch = state(null);
  loading = state(true);
  activeTab = state("active-staff");

  // Staff state
  staff = state([]);
  invitations = state([]);
  roles = state([]);
  loadingStaff = state(true);

  // Suggestions state
  suggestions = state([]);
  loadingSuggestions = state(false);
  showSuggestions = state(false);
  searchTimeout = null;

  // Branch Info State (Edit Form)
  formData = {
    name: "",
    location: "",
    latitude: "",
    longitude: "",
    readable_address: "",
    contact_phone: "",
    contact_email: "",
  };
  pickedLocation = state("");

  $$branch = {
    updated: (ed) => {
      const { message } = eParse(ed);
      this.branch.value = message.branch;
      this.syncFormData(message.branch);
      const btn = dom.id(`update-branch-btn-${this.id}`);
      dom.enable(btn);
      h.span("Update Branch Details", { parent: btn, resetParent: true });
    },
    staff: {
      created: () => this.fetchStaffData(),
      deleted: () => this.fetchStaffData(),
      has: {
        creationError: (ed) => this.handleActionError(ed),
        deletionError: (ed) => this.handleActionError(ed),
      },
      invitation: {
        created: () => {
          this.fetchStaffData();
          this.clearInviteForm();

          const btn = dom.id(`send-invitation-${this.id}`);
          if (btn) {
            dom.enable(btn);
            h.span("Send Invitation", { parent: btn, resetParent: true });
            h.i("fas fa-chevron-right", { parent: btn });
          }
        },
        cancelled: () => this.fetchStaffData(),
        has: {
          creationError: (ed) => {
            this.handleActionError(ed);
            const btn = dom.id(`send-invitation-${this.id}`);
            if (btn) {
              dom.enable(btn);
              h.span("Send Invitation", { parent: btn, resetParent: true });
              h.i("fas fa-chevron-right", { parent: btn });
            }
          },
          cancellationError: (ed) => {
            this.handleActionError(ed);
            const { meta } = eParse(ed);
            const btn = dom.id(meta.btnId);
            if (btn) {
              dom.enable(btn);
              h.span("Cancel", { parent: btn, resetParent: true });
              h.i("fas fa-trash", { parent: btn });
            }
          },
        },
      },
    },
    has: {
      updateError: (ed) => {
        this.handleActionError(ed);
        const btn = dom.id(`update-branch-btn-${this.id}`);
        dom.enable(btn);
        h.span("Update Branch Details", { parent: btn, resetParent: true });
      },
    },
  };

  $$map = {
    has: {
      location: (ed) => {
        let { meta, message } = eParse(ed);
        if (meta.from !== "EDIT_BRANCH_ADDRESS_FORM") return;

        this.formData.latitude = message.latitude;
        this.formData.longitude = message.longitude;
        this.formData.location = message.address;
        this.pickedLocation.value = message.address;

        inform("Location selected!", "success");
      },
    },
  };

  render() {
    this.branchId = router.params.branchId;
    this.companyId = router.params.companyId;
    scrollToTop();

    if (this.loading.value) {
      this.fetchBranch();
    }

    return h.div(
      { class: "min-vh-100 py-5 mb-5 py-md-5" },
      h.div(
        { class: "container" },
        // Header
        h.div(
          { class: "mb-5 d-flex align-items-center gap-3" },
          h.button(
            {
              class: "btn btn-white border shadow-sm rounded-circle p-2",
              listeners: {
                click: () => history.back(),
              },
            },
            h.SolidIcon("arrow-left"),
          ),
          h.div(
            v(this.branch, (b) =>
              h.div(
                h.h2(
                  { class: "fw-bold mb-0" },
                  b.value?.name || "Manage Branch",
                ),
                h.p(
                  { class: "text-muted mb-0" },
                  b.value?.readable_address || "Branch Details",
                ),
              ),
            ),
          ),
        ),

        // Tabs
        h.div(
          { class: "chrome-tabs-wrapper mb-0" },
          this.renderTabTrigger("active-staff", "Staff", "people"),
          this.renderTabTrigger("invitations", "Invitations", "envelope-paper"),
          this.renderTabTrigger("info", "Information", "info-circle"),
        ),

        // Tab Content
        h.div(
          {
            class: "chrome-tab-content bg-white shadow-sm",
            style: "border-radius: 0 0 20px 20px;",
          },
          v(this.activeTab, (tab) => {
            if (tab.value === "active-staff")
              return this.renderActiveStaffTab();
            if (tab.value === "invitations") return this.renderInvitationsTab();
            if (tab.value === "info") return this.renderBranchInfoTab();
            return null;
          }),
        ),
      ),
    );
  }

  renderTabTrigger(id, label, icon) {
    return v(this.activeTab, (tab) => {
      return h.button(
        {
          class: `d-flex align-items-center gap-1 chrome-tab ${tab.value === id ? "active" : ""}`,
          listeners: {
            click: () => (this.activeTab.value = id),
          },
        },
        h.i({ class: `bi bi-${icon} me-2` }),
        h.span(label),
      );
    });
  }

  renderActiveStaffTab() {
    if (this.loadingStaff.value) {
      this.fetchStaffData();
    }

    return h.div(
      { class: "py-4" },
      h.h5({ class: "fw-bold mb-4" }, "Active Staff Members"),
      v(this.loadingStaff, (l) => {
        if (l.value) return h.div({ class: "text-center py-5" }, h.Spinner());

        return v(this.staff, (s) => {
          if (s.value.length === 0) {
            return h.div(
              {
                class: "text-center py-5 bg-light rounded-4 border-dashed",
                style: "border: 2px dashed #dee2e6;",
              },
              h.div(
                { class: "text-muted mb-2" },
                h.i({ class: "bi bi-people fs-1" }),
              ),
              h.p(
                { class: "text-muted mb-0" },
                "You haven't added any staff members yet.",
              ),
            );
          }

          return h.div(
            { class: "d-grid gap-3" },
            ...s.value.map((member) => this.renderStaffItem(member)),
          );
        });
      }),
    );
  }

  renderInvitationsTab() {
    if (this.loadingStaff.value) {
      this.fetchStaffData();
    }

    return h.div(
      { class: "row g-5 py-4" },
      // Invite Staff Card
      h.div(
        { class: "col-12 col-lg-5" },
        h.div(
          {
            class: "card border-1",
            style: "border-radius: 20px;",
          },
          h.div(
            { class: "card-body p-4 p-md-5" },
            h.h4({ class: "fw-bold mb-4" }, "Invite New Staff"),
            h.p(
              { class: "text-muted small mb-4" },
              "Send an invitation to a user to join your branch.",
            ),

            h.div(
              { class: "mb-4 position-relative" },
              h.label(
                {
                  class:
                    "form-label fw-600 small text-uppercase text-muted mb-1",
                },
                "Username or Email",
              ),
              h.input({
                class: "form-control bg-light border",
                placeholder: "Enter username or email",
                id: "invite-username",
                style: "padding: 0.75rem 1rem;",
                listeners: {
                  input: (e) => this.handleSearchInput(e),
                  focus: () => {
                    if (this.suggestions.value.length > 0)
                      this.showSuggestions.value = true;
                  },
                },
              }),
              // Suggestions Dropdown
              v(this.showSuggestions, (show) => {
                if (!show.value) return null;
                return h.div(
                  {
                    class:
                      "position-absolute w-100 bg-white shadow-lg rounded-4 mt-2 overflow-hidden border",
                    style: "z-index: 1000; top: 100%; left: 0;",
                  },
                  v(this.loadingSuggestions, (loading) => {
                    if (loading.value)
                      return h.div(
                        { class: "p-4 text-center" },
                        h.div({
                          class:
                            "spinner-border spinner-border-sm text-primary",
                        }),
                      );

                    return v(this.suggestions, (sugs) => {
                      if (sugs.value.length === 0)
                        return h.div(
                          { class: "p-4 text-muted small text-center" },
                          "No users found matching your search.",
                        );

                      return h.div(
                        { class: "list-group list-group-flush" },
                        ...sugs.value.map((user) =>
                          h.button(
                            {
                              class:
                                "list-group-item list-group-item-action border-0 d-flex align-items-center gap-3 py-3 px-4",
                              listeners: {
                                click: () => this.selectSuggestion(user),
                              },
                            },
                            h.img({
                              src:
                                user.profile_photo_path ||
                                "/assets/images/user-avatar.png",
                              class: "rounded-circle",
                              style:
                                "width: 32px; height: 32px; object-fit: cover;",
                            }),
                            h.div(
                              h.div(
                                { class: "fw-bold text-dark" },
                                user.display_name || user.name,
                              ),
                              h.div(
                                { class: "text-muted small" },
                                `@${user.username}`,
                              ),
                            ),
                          ),
                        ),
                      );
                    });
                  }),
                );
              }),
            ),
            h.div(
              { class: "mb-5" },
              h.label(
                {
                  class:
                    "form-label fw-600 small text-uppercase text-muted mb-1",
                },
                "Assign Role",
              ),
              h.select(
                {
                  class: "form-select bg-light border",
                  id: "invite-role",
                  style: "padding: 0.75rem 1rem;",
                },
                h.option({ value: "" }, "Select a role for this user"),
                v(this.roles, (r) =>
                  r.value.map((role) =>
                    h.option({ value: role.name }, role.name),
                  ),
                ),
              ),
            ),
            h.button(
              {
                class:
                  "btn btn-primary w-100 rounded-pill py-3 fw-bold d-flex align-items-center justify-content-center gap-2 shadow-sm",
                id: `send-invitation-${this.id}`,
                listeners: {
                  click: (e) => this.sendInvitation(e.target),
                },
              },
              h.span("Send Invitation"),
              h.SolidIcon("chevron-right"),
            ),
          ),
        ),
      ),

      // Pending Invitations List
      h.div(
        { class: "col-12 col-lg-7" },
        h.h5(
          { class: "fw-bold mb-4 d-flex align-items-center gap-2" },
          "Pending Invitations",
          v(this.invitations, (inv) =>
            h.span(
              {
                class: "badge bg-info text-white rounded-pill small",
                style: "font-size: 0.7rem;",
              },
              inv.value.length,
            ),
          ),
        ),
        v(this.invitations, (inv) => {
          if (inv.value.length === 0) {
            return h.div(
              {
                class: "text-center py-5 bg-light rounded-4 border-dashed",
                style: "border: 2px dashed #dee2e6;",
              },
              h.p({ class: "text-muted mb-0" }, "No pending invitations."),
            );
          }
          return h.div(
            { class: "d-grid gap-3" },
            ...inv.value.map((i) => this.renderInvitationItem(i)),
          );
        }),
      ),
    );
  }

  renderBranchInfoTab() {
    return h.div(
      { class: "py-4 max-w-800" },
      h.div(
        { class: "card border-0" },
        h.div(
          { class: "card-body p-0" },
          h.h4({ class: "fw-bold mb-4" }, "Edit Branch Details"),
          this.renderBranchEditForm(),
          h.div(
            { class: "mt-5" },
            h.button(
              {
                class:
                  "btn btn-primary rounded-pill px-5 py-3 fw-bold shadow-sm",
                id: `update-branch-btn-${this.id}`,
                listeners: {
                  click: (e) => this.updateBranch(e.target),
                },
              },
              "Update Branch Details",
            ),
          ),
        ),
      ),
    );
  }

  renderBranchEditForm() {
    return h.div(
      { class: "row g-4" },
      h.div(
        { class: "col-12" },
        h.label(
          { class: "form-label small text-uppercase fw-bold text-muted" },
          "Branch Name",
        ),
        h.input({
          class: "form-control bg-light border p-3",
          value: this.formData.name,
          placeholder: "e.g. Nairobi Branch",
          listeners: {
            input: (e) => (this.formData.name = e.target.value),
          },
        }),
        h.small(
          { class: "text-muted" },
          "Enter a name that helps you identify this branch (e.g. 'Town Center' or 'Westlands Shop').",
        ),
      ),

      h.div(
        { class: "col-12 col-md-6" },
        h.label(
          { class: "form-label small text-uppercase fw-bold text-muted" },
          "Contact Phone",
        ),
        h.input({
          class: "form-control bg-light border p-3",
          type: "tel",
          value: this.formData.contact_phone,
          placeholder: "e.g. 0712345678",
          listeners: {
            input: (e) => (this.formData.contact_phone = e.target.value),
          },
        }),
        h.small(
          { class: "text-muted" },
          "The phone number customers or staff can use to reach this branch.",
        ),
      ),

      h.div(
        { class: "col-12 col-md-6" },
        h.label(
          { class: "form-label small text-uppercase fw-bold text-muted" },
          "Contact Email",
        ),
        h.input({
          class: "form-control bg-light border p-3",
          type: "email",
          value: this.formData.contact_email,
          placeholder: "e.g. branch@example.com",
          listeners: {
            input: (e) => (this.formData.contact_email = e.target.value),
          },
        }),
        h.small(
          { class: "text-muted" },
          "The email address where branch-related messages will be sent.",
        ),
      ),

      h.div(
        { class: "col-12" },
        h.label(
          { class: "form-label small text-uppercase fw-bold text-muted" },
          "Map Location",
        ),
        h.div(
          { class: "d-flex flex-column gap-2" },
          h.button(
            {
              class:
                "btn btn-outline-primary d-flex align-items-center gap-2 w-100 justify-content-center py-3 rounded-4 border-2",
              style: "border-style: dashed;",
              listeners: {
                click: () => this.openMap(),
              },
            },
            h.i({ class: "bi bi-geo-alt-fill fs-4" }),
            "Change Location on Map",
          ),
          v(this.pickedLocation, (p) =>
            p.value
              ? h.div(
                  { class: "p-3 bg-light rounded-3 border" },
                  h.div(
                    { class: "small text-muted mb-1" },
                    "Selected Location:",
                  ),
                  h.div({ class: "fw-bold" }, p.value),
                )
              : null,
          ),
          h.small(
            { class: "text-muted" },
            "Click the button above to mark exactly where your branch is located on the map.",
          ),
        ),
      ),

      h.div(
        { class: "col-12" },
        h.label(
          { class: "form-label small text-uppercase fw-bold text-muted" },
          "Detailed Address",
        ),
        h.textarea(
          {
            class: "form-control bg-light border p-3",
            rows: 3,
            placeholder: "e.g. Shop G10, Ground Floor, Diamond Plaza...",
            listeners: {
              input: (e) => (this.formData.readable_address = e.target.value),
            },
          },
          this.formData.readable_address,
        ),
        h.small(
          { class: "text-muted" },
          "Provide specific details like shop number or floor to help customers and deliverers find you easily.",
        ),
      ),
    );
  }

  renderInvitationItem(invitation) {
    return h.div(
      { class: "col-12" },
      h.div(
        {
          class:
            "card border-0 shadow-sm rounded-4 border-start border-info border-4",
          style: "background: #fdfdfd;",
        },
        h.div(
          { class: "card-body p-4 d-flex align-items-center gap-4" },
          h.div(
            {
              class:
                "bg-info-subtle text-info circle d-flex align-items-center justify-content-center",
              style: "width: 50px; height: 50px;",
            },
            h.i({ class: "bi bi-envelope-paper fs-4" }),
          ),
          h.div(
            { class: "d-flex gap-4 flex-wrap" },
            h.div(
              { class: "flex-fill" },
              h.h6(
                { class: "fw-bold mb-1 text-dark" },
                invitation.display_name ||
                  invitation.email ||
                  invitation.username,
              ),
              h.div(
                { class: "d-flex align-items-center gap-2" },
                h.span(
                  { class: "text-muted small" },
                  `@${invitation.username || "unknown"}`,
                ),
                h.span(
                  {
                    class:
                      "badge bg-light text-info border border-info-subtle rounded-pill fw-normal",
                  },
                  invitation.role,
                ),
              ),
              h.div(
                { class: "text-muted small mt-1" },
                h.i({ class: "bi bi-clock-history me-1" }),
                `Expires ${invitation.expires_in}`,
              ),
            ),
            h.div(
              { class: "text-end" },
              h.button(
                {
                  class:
                    "btn btn-outline-danger btn-sm rounded-pill px-3 d-flex align-items-center gap-2",
                  id: `cancel-invitation-${this.id}-${invitation.id}`,
                  onclick: this.method("cancelInvitation", [
                    "${this}",
                    invitation,
                  ]),
                },
                h.span("Cancel"),
                h.SolidIcon("trash", { class: "small" }),
              ),
            ),
          ),
        ),
      ),
    );
  }

  renderStaffItem(member) {
    return h.div(
      { class: "col-12" },
      h.div(
        { class: "card border-0 shadow-sm rounded-4" },
        h.div(
          { class: "card-body p-4 d-flex align-items-center gap-4" },
          h.img({
            src: member.profile_photo_path || "/assets/images/user-avatar.png",
            class: "rounded-circle border",
            style: "width: 56px; height: 56px; object-fit: cover;",
          }),
          h.div(
            { class: "flex-fill" },
            h.h6(
              { class: "fw-bold mb-1 text-dark" },
              member.display_name || member.name,
            ),
            h.div(
              { class: "d-flex align-items-center gap-2 mt-1" },
              h.p({ class: "text-muted small mb-0" }, `@${member.username}`),
              h.span(
                {
                  class:
                    "badge bg-primary-subtle text-primary rounded-pill fw-normal",
                },
                member.pivot?.role || "Staff",
              ),
            ),
          ),
          h.div(
            { class: "dropdown" },
            h.button(
              {
                class: "btn btn-light btn-sm rounded-circle p-2",
                data_bs_toggle: "dropdown",
              },
              h.i({ class: "bi bi-three-dots-vertical" }),
            ),
            h.ul(
              {
                class:
                  "dropdown-menu dropdown-menu-end border-0 shadow-lg rounded-4 overflow-hidden",
              },
              h.li(
                h.button(
                  {
                    class: "dropdown-item py-2 px-4",
                    listeners: {
                      click: () => this.changeStaffRole(member),
                    },
                  },
                  h.i({ class: "bi bi-pencil-square me-2" }),
                  "Change Role",
                ),
              ),
              h.li(h.hr({ class: "dropdown-divider m-0" })),
              h.li(
                h.button(
                  {
                    class: "dropdown-item text-danger py-2 px-4",
                    listeners: {
                      click: () => this.removeStaff(member),
                    },
                  },
                  h.i({ class: "bi bi-person-x me-2" }),
                  "Remove Staff",
                ),
              ),
            ),
          ),
        ),
      ),
    );
  }

  async fetchBranch() {
    try {
      const res = await api.get(
        `companies/${this.companyId}/branches/${this.branchId}`,
      );
      if (res) {
        this.branch.value = res.data.branch;
        this.syncFormData(res.data.branch);
      }
    } catch (e) {
      consoleErrorOnLocal(e);
    } finally {
      this.loading.value = false;
    }
  }

  syncFormData(branch) {
    this.formData.name = branch.name || "";
    this.formData.contact_phone = branch.contact_phone || "";
    this.formData.contact_email = branch.contact_email || "";
    this.formData.readable_address = branch.readable_address || "";
    this.formData.latitude = branch.latitude || "";
    this.formData.longitude = branch.longitude || "";
    this.formData.location = branch.location || "";
    this.pickedLocation.value = branch.readable_address || "";
  }

  async fetchStaffData() {
    try {
      const [staffRes, invRes, rolesRes] = await Promise.all([
        api.get(`branches/${this.branchId}/staff`),
        api.get(`branches/${this.branchId}/invitations`),
        api.get(`branches/${this.branchId}/available-roles`),
      ]);

      if (staffRes) this.staff.value = staffRes.data.staff;
      if (invRes) this.invitations.value = invRes.data.invitations;
      if (rolesRes) this.roles.value = rolesRes.data.roles;
    } catch (e) {
      consoleErrorOnLocal(e);
    } finally {
      this.loadingStaff.value = false;
    }
  }

  handleActionError(ed) {
    const { message } = eParse(ed);
    consoleErrorOnLocal(message);
  }

  clearInviteForm() {
    const usernameInput = document.getElementById("invite-username");
    const roleSelect = document.getElementById("invite-role");
    if (usernameInput) usernameInput.value = "";
    if (roleSelect) roleSelect.value = "";
  }

  sendInvitation(btn) {
    const usernameInput = document.getElementById("invite-username");
    const roleSelect = document.getElementById("invite-role");

    const username = usernameInput.value.trim();
    const role = roleSelect.value;

    if (!username) return inform("Please enter a username or email", "warning");
    if (!role) return inform("Please select a role", "warning");

    dom.disable(btn);
    h.Spinner({ parent: btn, resetParent: true });

    broker.send(
      $e.branch.staff.invitation.needs.creation,
      payload({
        branchId: this.branchId,
        identifier: username,
        role: role,
      }),
    );
  }

  cancelInvitation(btn, invitation) {
    dom.disable(btn);
    h.SmallSpinner({ parent: btn, resetParent: true });

    broker.send(
      $e.branch.staff.invitation.needs.cancellation,
      payload(
        {
          branchId: this.branchId,
          id: invitation.id,
        },
        { btnId: btn.id },
      ),
    );
  }

  removeStaff(member) {
    broker.send(
      $e.branch.staff.needs.deletion,
      payload({
        branchId: this.branchId,
        id: member.id,
      }),
    );
  }

  updateBranch(btn) {
    dom.disable(btn);
    h.Spinner({ parent: btn, resetParent: true });

    let d = { ...this.formData };
    d.id = this.branchId;
    d.businessId = this.companyId;

    broker.send($e.branch.needs.update, payload(d));
  }

  openMap() {
    broker.send(
      $e.location.is.needed,
      payload({}, { from: "EDIT_BRANCH_ADDRESS_FORM" }),
    );
  }

  changeStaffRole(member) {
    inform(`Changing role for ${member.display_name || member.name}`, "info");
  }

  handleSearchInput(e) {
    const query = e.target.value.trim();

    if (this.searchTimeout) clearTimeout(this.searchTimeout);

    if (query.length < 2) {
      this.suggestions.value = [];
      this.showSuggestions.value = false;
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.fetchSuggestions(query);
    }, 300);
  }

  async fetchSuggestions(query) {
    this.loadingSuggestions.value = true;
    this.showSuggestions.value = true;

    try {
      const res = await api.get("users/search", { q: query });
      if (res) {
        this.suggestions.value = res.data.result.data || [];
      }
    } catch (e) {
      consoleErrorOnLocal(e);
    } finally {
      this.loadingSuggestions.value = false;
    }
  }

  selectSuggestion(user) {
    const input = document.getElementById("invite-username");
    input.value = user.username;
    this.showSuggestions.value = false;
    this.suggestions.value = [];
  }
}

ojs(ManageBranch);
